import './index.css'
import '@market/web-components/dist/market/market.css'

import React from 'react'
import ReactDOM from 'react-dom'
import {
  applyPolyfills,
  defineCustomElements,
} from '@market/web-components/loader'

import App from 'App'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)

applyPolyfills().then(() => {
  defineCustomElements(window)
})
